module.exports = __webpack_public_path__ + "img/js.60ac2aab.jpg";